// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"I3-z"};